import React, { useState, useEffect } from 'react';
import Swal from 'sweetalert2';
import axios from 'axios';
import './ForgotPassword.css';

const api = axios.create({ baseURL: 'https://django-backend-115705416374.asia-south1.run.app' });
// const api = axios.create({ baseURL: 'http://localhost:8000' });

export default function ChangePassword({ username, tempAccessToken, onPasswordChanged }) {
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [logo, setLogo] = useState('Main.png'); // 🆕 State for logo

  // ✅ mark that user must stay on this page
  useEffect(() => {
    localStorage.setItem('mustChangePassword', 'true');

    // 🆕 Fetch active company logo
    const fetchLogo = async () => {
      try {
        const token = tempAccessToken || localStorage.getItem('access');
        if (token) {
          const res = await api.get('/api/active-company/', {
            headers: { Authorization: `Bearer ${token}` }
          });
          if (res.data.company && res.data.company.logo) {
            setLogo(res.data.company.logo);
          }
        }
      } catch (err) {
        console.error("Error fetching logo:", err);
      }
    };
    fetchLogo();
  }, [tempAccessToken]);

  const validatePassword = (pwd) => {
    const regex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]).{12,}$/;
    return regex.test(pwd);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (newPassword !== confirmPassword) {
      Swal.fire({ icon: 'error', title: 'Passwords do not match' });
      return;
    }
    if (!validatePassword(newPassword)) {
      Swal.fire({
        icon: 'error',
        title: 'Invalid Password',
        html: `Password must be at least 12 characters long and include:<br/>
               - Uppercase<br/>
               - Lowercase<br/>
               - Digit<br/>
               - Special character`
      });
      return;
    }

    try {
      setLoading(true);

      const accessToken = tempAccessToken || localStorage.getItem('access');
      if (!accessToken) throw new Error('Access token missing. Please login again.');

      await api.post(
        '/api/change-temp-password/',
        { new_password: newPassword, confirm_password: confirmPassword },
        { headers: { Authorization: `Bearer ${accessToken}` } }
      );
      Swal.fire({
        icon: 'success',
        title: 'Password successfully changed!',
        text: 'Now you can log in.',
      }).then(() => {
        // ✅ remove flag so user can move forward
        localStorage.removeItem('mustChangePassword');
        localStorage.removeItem('access'); // optional: force re-login
        if (onPasswordChanged) onPasswordChanged();
        else window.location.href = '/'; // fallback
      });

    } catch (err) {
      Swal.fire({
        icon: 'error',
        title: 'Failed',
        text: err.response?.data?.error || err.message,
      }).then(() => {
        // Clear fields on failure
        setNewPassword('');
        setConfirmPassword('');
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-box">
      {/* 🆕 Use dynamic logo */}
      <img draggable={false} src={process.env.PUBLIC_URL + '/' + logo} alt="Company Logo" className="logo" />
      <h2>Change Password</h2>

      <form onSubmit={handleSubmit}>
        <div className="input-wrapper">
          <input
            type="password"
            placeholder="New Password"
            value={newPassword}
            onChange={e => setNewPassword(e.target.value)}
            disabled={loading}
            readOnly={loading}
          />
        </div>

        <div className="input-wrapper">
          <input
            type="password"
            placeholder="Confirm Password"
            value={confirmPassword}
            onChange={e => setConfirmPassword(e.target.value)}
            disabled={loading}
            readOnly={loading}
          />
        </div>

        <button type="submit" disabled={loading}>
          {loading ? 'Submitting...' : 'Submit'}
        </button>
      </form>
    </div>
  );
}

